import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CaseState {
  activeCaseId: string | null;
  activeCaseName: string | null;
  setActiveCase: (id: string, name: string) => void;
  clearActiveCase: () => void;
}

export const useCaseStore = create<CaseState>()(
  persist(
    (set) => ({
      activeCaseId: null,
      activeCaseName: null,
      setActiveCase: (id, name) =>
        set({ activeCaseId: id, activeCaseName: name }),
      clearActiveCase: () =>
        set({ activeCaseId: null, activeCaseName: null }),
    }),
    { name: "athena.activeCase" },
  ),
);
